import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDStations_Form_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDStations_Form_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  SelectSTDStations1: any[];
  SelectSTDStations1_dummy: any[];
  GetStationDetail: any[];
  GetStationDetail_dummy: any[];
  GetAllCustomers: any[];
  GetAllCustomers_dummy: any[];
  STDStationsSave: number;
  STDStationsSave_dummy: number;
  ReturnStringEverthing: string;
  ReturnStringEverthing_dummy: string;
  STDLogsSave: number;
  STDLogsSave_dummy: number;
}

export class STDStations_Form_ScreenBase extends React.PureComponent<
  ISTDStations_Form_ScreenProps,
  any
> {
  stdstations_form_125967_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "938d89a6-5739-4da2-8c78-749f2f33864f",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 327031, PropertyName: "value", Value: "İstasyon Form" },
        { Id: 453405, PropertyName: "value", Value: "Aktiflik" },
        { Id: 378549, PropertyName: "value", Value: "Firma Adı" },
        { Id: 125967, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 897357, PropertyName: "value", Value: "İstasyon Adı" },
        { Id: 176340, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 702120, PropertyName: "value", Value: "İstasyon Lokasyonu" },
        { Id: 177927, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 474480, PropertyName: "value", Value: "Teslimat Adresi" },
        { Id: 428319, PropertyName: "placeholder", Value: "15" },
        { Id: 98351, PropertyName: "value", Value: "İstasyon Adresi" },
        { Id: 594268, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 56701, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdstations_form_125967_value_kuikaSelectBoxRef = React.createRef();
    this.stdstations_form_176340_value_kuikaTextInputRef = React.createRef();
    this.stdstations_form_177927_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetUserWithGroupDetails: [],
      IfThenElse: false,
      SelectSTDStations1: [],
      GetStationDetail: [],
      GetAllCustomers: [],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdstations_form", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDStations_FormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdstations_form", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdstations_form", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDStations_FormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stdstations_form_717486_value:
        this.state.SelectSTDStations1?.at?.(0)?.stationStatus ?? undefined,
      stdstations_form_125967_value:
        this.state.GetStationDetail?.at?.(0)?.customerId ?? undefined,
      stdstations_form_176340_value:
        this.state.GetStationDetail?.at?.(0)?.stationName ?? undefined,
      stdstations_form_177927_value:
        this.state.GetStationDetail?.at?.(0)?.stationLocation ?? undefined,
      stdstations_form_428319_value:
        this.state.GetStationDetail?.at?.(0)?.stationLocationNo ?? undefined,
      stdstations_form_594268_value:
        this.state.GetStationDetail?.at?.(0)?.stationAddress ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDStations_FormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDStations_Form/STDStations_FormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDStations_FormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDStations_FormPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDStations_Form",
      "NavigateScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDStations_FormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsCreate
            : null
        ),
        true
      ) ||
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsEdit
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.STDStations_FormPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDStations_FormPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDStations_FormPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDStations_Form/STDStations_FormPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectSTDStations1 = result?.data.selectSTDStations1;
    formVars.stdstations_form_717486_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDStations1 !== undefined
        ? stateVars.SelectSTDStations1?.length > 0
          ? stateVars.SelectSTDStations1[0].stationStatus
          : null
        : this.state.SelectSTDStations1?.length > 0
        ? this.state.SelectSTDStations1[0].stationStatus
        : null
    );
    stateVars.GetStationDetail = result?.data.getStationDetail;
    formVars.stdstations_form_125967_value =
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].customerId
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].customerId
        : null;
    formVars.stdstations_form_125967_options = stateVars.GetAllCustomers;
    formVars.stdstations_form_176340_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationName
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationName
        : null
    );
    formVars.stdstations_form_177927_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationLocation
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationLocation
        : null
    );
    formVars.stdstations_form_428319_value = ReactSystemFunctions.value(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationLocationNo
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationLocationNo
        : null
    );
    formVars.stdstations_form_594268_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationAddress
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationAddress
        : null
    );
    stateVars.GetAllCustomers = result?.data.getAllCustomers;

    formVars.stdstations_form_125967_value =
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].customerId
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].customerId
        : null;
    formVars.stdstations_form_125967_options = stateVars.GetAllCustomers;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDStations_FormPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDStations_FormPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdstations_form_717486_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDStations1 !== undefined
        ? stateVars.SelectSTDStations1?.length > 0
          ? stateVars.SelectSTDStations1[0].stationStatus
          : null
        : this.state.SelectSTDStations1?.length > 0
        ? this.state.SelectSTDStations1[0].stationStatus
        : null
    );

    formVars.stdstations_form_125967_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].customerId
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].customerId
        : null
    );

    stateVars.dataSource_125967 =
      stateVars.GetAllCustomers ?? this.state.GetAllCustomers;
    stateVars.dataSource_125967 =
      stateVars.GetAllCustomers ?? this.state.GetAllCustomers;
    formVars.stdstations_form_176340_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationName
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationName
        : null
    );

    formVars.stdstations_form_177927_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationLocation
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationLocation
        : null
    );

    formVars.stdstations_form_428319_value = ReactSystemFunctions.value(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationLocationNo
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationLocationNo
        : null
    );

    formVars.stdstations_form_594268_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationAddress
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationAddress
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDStations_FormComponent_909921_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDStations_FormComponent_56701_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdstations_form_125967_value",
          "value",
          "GetAllCustomers",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdstations_form_125967_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdstations_form_594268_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdstations_form_594268_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdstations_form_177927_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdstations_form_177927_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdstations_form_428319_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdstations_form_428319_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdstations_form_176340_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdstations_form_176340_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CreatedAt_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDStations1 !== undefined
            ? stateVars.SelectSTDStations1?.length > 0
              ? stateVars.SelectSTDStations1[0].createdAt
              : null
            : this.state.SelectSTDStations1?.length > 0
            ? this.state.SelectSTDStations1[0].createdAt
            : null
        ),
        "Date"
      ),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_125967_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationAddress_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_594268_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      StationLocation_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_177927_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      StationLocationNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_428319_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      StationName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_176340_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      StationStatus_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_717486_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      UpdatedAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      parameter1_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "İstasyon bilgisi güncellendi:",
          "string"
        ),
        "string"
      ),
      parameter2_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_176340_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_2: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CreatedUserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      EventId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      LogStatus_2: ReactSystemFunctions.convertToTypeByName(5, "number"),
      LogText_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.ReturnStringEverthing),
        "string"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDStations_Form/STDStations_FormComponent_56701_onClick_if0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDStationsSave = result?.data.stdStationsSave;
    stateVars.ReturnStringEverthing = result?.data.returnStringEverthing;
    stateVars.STDLogsSave = result?.data.stdLogsSave;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  STDStations_FormComponent_56701_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdstations_form_125967_value",
          "value",
          "GetAllCustomers",
          "id",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdstations_form_125967_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdstations_form_594268_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdstations_form_594268_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdstations_form_177927_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdstations_form_177927_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdstations_form_428319_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdstations_form_428319_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdstations_form_176340_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdstations_form_176340_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CreatedAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_125967_value",
            "value",
            "GetAllCustomers",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationAddress_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_594268_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      StationLocation_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_177927_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      StationLocationNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_428319_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      StationName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_176340_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      StationStatus_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_717486_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      UpdatedAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      parameter1_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("İstasyon eklendi:", "string"),
        "string"
      ),
      parameter2_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdstations_form_176340_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_2: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CreatedUserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      EventId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      LogStatus_2: ReactSystemFunctions.convertToTypeByName(3, "number"),
      LogText_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.ReturnStringEverthing),
        "string"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDStations_Form/STDStations_FormComponent_56701_onClick_else0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDStationsSave = result?.data.stdStationsSave;
    stateVars.ReturnStringEverthing = result?.data.returnStringEverthing;
    stateVars.STDLogsSave = result?.data.stdLogsSave;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  STDStations_FormComponent_56701_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDStations1 !== undefined
            ? stateVars.SelectSTDStations1?.length > 0
              ? stateVars.SelectSTDStations1[0].id
              : null
            : this.state.SelectSTDStations1?.length > 0
            ? this.state.SelectSTDStations1[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.STDStations_FormComponent_56701_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDStations_FormComponent_56701_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["STDStations_Form"] ??
        false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.STDStations_FormPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.STDStations_FormPageInit();
    }
  }
}
